import { useTranslation } from 'react-i18next';

const NyseStepOne = () => {
  const { t } = useTranslation(['contractModal']);

  return (
    <div className={'contracts-steps-body'}>
      <h1 style={{ textTransform: 'uppercase' }}>
        {t(
          'contractModal:nyse_modal.agreement_for_market_data_display_services',
        )}
      </h1>
      <div>
        <p>{t('contractModal:nyse_modal.nonprofessional_subscriber_status')}</p>
      </div>
    </div>
  );
};

export default NyseStepOne;
